<script lang="ts">
    // VITRINE DOS COMPONENTES — /debug?showcase=1
    //
    // Catálogo vivo do design system: cada peça aparece funcionando, com uma linha dizendo QUANDO
    // usar e quando não usar. Serve para três coisas:
    //   1. conferir altura, alinhamento e os dois temas lado a lado;
    //   2. decidir qual componente usar sem ter que ler o código de três telas;
    //   3. descobrir que uma peça nova já existe antes de escrever a quarta versão dela.
    //
    // Ao criar um componente genérico, acrescente uma seção aqui. Ordem: campos, escolhas,
    // entidades, blocos, listas, botões.
    import { faPlus, faTrashAlt, faCheck } from '@fortawesome/free-solid-svg-icons'
    import Content from '../content.svelte'
    import Zinput from './zinput.svelte'
    import Zbutton from './zbutton.svelte'
    import ZContainer from './z-container.svelte'
    import ZContainerCol from './z-container-col.svelte'
    import ZContainerRow from './z-container-row.svelte'
    import Zframe from './zframe.svelte'
    import Zblock from './zblock.svelte'
    import ZentitySelect from './zentity-select.svelte'
    import ZsheetSection from './sheet/zsheet-section.svelte'
    import ZsheetEntity from './sheet/zsheet-entity.svelte'
    import ZsheetAdd from './sheet/zsheet-add.svelte'
    import Zoption from './zoption.svelte'
    import Zfab from './zfab.svelte'
    import DateSelect from '../date-select.svelte'
    import DateSelectMonth from '../date-select-month.svelte'

    let text = 'Cleyton Santos'
    let textEmpty = ''
    let num = 120
    let date: any = new Date()
    let time: any = new Date()
    let month: any = new Date()
    let selectValue = 'b'
    let multi = ['a']
    let toggle = true
    let inline = 'b'
    let inline2 = 'a'
    let area = 'Cliente alérgica a amônia — usar linha sem amônia.'
    let color = '#2ecc71'
    // campos em destaque: o destaque é do chamador, então aqui ele mora numa variável que só o
    // botão "Conferido" apaga — digitar nos campos não muda nada
    let destaque: '' | 'attention' | 'danger' = 'attention'
    let hlSerie = '1'
    let hlNumero = ''
    let hlEmissao: any = null

    // último período aplicado em cada seletor (DateSelect / DateSelectMonth)
    let periodo: { from: Date; to: Date } = null
    let periodoMes: { from: Date; to: Date } = null

    // entidades escolhidas pelo ZentitySelect
    let pessoa = null
    let usuario = null
    let conta = null
    let categoria = null

    const options = [
        { value: 'a', label: 'Primeira opção' },
        { value: 'b', label: 'Segunda opção' },
        { value: 'c', label: 'Terceira opção' },
    ]
    const act = { label: '', icon: faPlus, callback: () => {} }
</script>

<Content footer={true}>
    <div class="root-content showcase">
        <!-- ================= CAMPOS ================= -->
        <Zframe class="h-space" title="Campos preenchidos" headline="Zinput — um campo é sempre um Zinput; não monte campo com .form-control.">
            <ZContainer gapRow="8px" gapCol="8px">
                <Zinput size={4} label="Texto" type="text" bind:value={text} />
                <Zinput size={4} label="Número" type="number" bind:value={num} />
                <Zinput size={4} label="Com ação" type="text" acts={[act]} bind:value={text} />
                <Zinput size={3} label="Data" type="date" bind:value={date} />
                <Zinput size={3} label="Hora" type="time" bind:value={time} />
                <Zinput size={3} label="Mês" type="month" bind:value={month} />
                <Zinput size={3} label="Seleção" type="select" {options} bind:value={selectValue} />
                <Zinput size={6} label="Múltipla escolha" type="multiselect" {options} bind:value={multi} />
                <Zinput size={6} label="Cor" type="color" bind:value={color} />
                <Zinput size={12} label="Texto longo" type="textarea" rows={2} bind:value={area} />
            </ZContainer>
        </Zframe>

        <Zframe class="h-space" title="Campos vazios e desabilitados" headline="Vazio, o rótulo desce e faz as vezes de instrução. Desabilitado é leitura, não bloco cinza.">
            <ZContainer gapRow="8px" gapCol="8px">
                <Zinput size={4} label="Vazio" type="text" bind:value={textEmpty} />
                <Zinput size={4} label="Obrigatório" type="text" required={true} bind:value={textEmpty} />
                <Zinput size={4} label="Desabilitado" type="text" disabled={true} value="Não editável" />
                <Zinput size={4} label="Data vazia" type="date" value={null} />
                <Zinput size={4} label="Hora vazia" type="time" value={null} />
                <Zinput size={4} label="Seleção vazia" type="select" {options} value={null} />
            </ZContainer>
        </Zframe>

        <Zframe
            class="h-space"
            title="Campos em destaque"
            headline="highlight aponta o que precisa de atenção (verde) ou o que está errado (vermelho). Sai só quando a propriedade muda — digitar não apaga."
        >
            <ZContainer gapRow="8px" gapCol="8px">
                <Zinput size={3} label="Série" type="text" highlight={destaque} bind:value={hlSerie} />
                <Zinput size={3} label="Número" type="text" highlight={destaque} bind:value={hlNumero} />
                <Zinput size={3} label="Emissão" type="date" highlight={destaque} bind:value={hlEmissao} />
                <Zinput size={3} label="Sem destaque" type="text" bind:value={text} />
            </ZContainer>
            <div class="d-flex flex-wrap mt-3" style="gap:8px">
                <Zbutton label="Pendente" color={destaque === 'attention' ? 'primary' : 'secondary'} on:click={() => (destaque = 'attention')} />
                <Zbutton label="Com erro" color={destaque === 'danger' ? 'red' : 'secondary'} on:click={() => (destaque = 'danger')} />
                <Zbutton label="Conferido" icon={faCheck} color={destaque === '' ? 'green' : 'secondary'} on:click={() => (destaque = '')} />
            </div>
        </Zframe>

        <Zframe class="h-space" title="Período" headline="DateSelect para intervalo de dias, DateSelectMonth para meses. O dropdown é o mesmo do filtro de data do Zgrid2.">
            <div class="d-flex flex-wrap" style="gap:12px">
                <DateSelect on:change={(event) => (periodo = event.detail)} />
                <DateSelectMonth on:change={(event) => (periodoMes = event.detail)} />
            </div>
            {#if periodo || periodoMes}
                <div class="showcase_period mt-2">
                    {#if periodo}Dias: {periodo.from.toLocaleString()} – {periodo.to.toLocaleString()}{/if}
                    {#if periodoMes}<br />Meses: {periodoMes.from.toLocaleString()} – {periodoMes.to.toLocaleString()}{/if}
                </div>
            {/if}
        </Zframe>

        <!-- ================= ESCOLHAS ================= -->
        <Zframe class="h-space" title="Escolher uma opção" headline="Poucas opções e decisão rápida: em linha. Muitas: lista. Nunca as duas coisas na mesma tela.">
            <ZContainer gapRow="8px" gapCol="8px">
                <Zinput size={6} label="Em linha (padrão)" type="inlineselect_2" {options} bind:value={inline2} />
                <Zinput size={6} label="Em lista" type="select" {options} bind:value={selectValue} />
                <Zinput size={6} label="Em linha — versão antiga" type="inlineselect" {options} bind:value={inline} />
                <Zinput size={6} label="Interruptor" type="toggle" bind:value={toggle} />
            </ZContainer>
            <div class="nota">
                <b>inlineselect</b> (sem o _2) está em fim de vida — use <b>inlineselect_2</b>, que é feito de Zbutton e herda cor, foco e estado de graça.
            </div>
        </Zframe>

        <!-- ================= ENTIDADES ================= -->
        <Zframe
            class="h-space"
            title="Escolher uma entidade do sistema"
            headline="ZentitySelect — pessoa, usuário, conta, categoria… Um componente só; a entidade é um parâmetro."
        >
            <ZContainer gapRow="8px" gapCol="8px">
                <ZContainerCol size={6} sizeM={12}>
                    <ZentitySelect fonte="pessoa" bind:value={pessoa} />
                </ZContainerCol>
                <ZContainerCol size={6} sizeM={12}>
                    <ZentitySelect fonte="usuario" bind:value={usuario} />
                </ZContainerCol>
                <ZContainerCol size={6} sizeM={12}>
                    <ZentitySelect fonte="conta" bind:value={conta} />
                </ZContainerCol>
                <ZContainerCol size={6} sizeM={12}>
                    <ZentitySelect fonte="categoriaFinanceira" bind:value={categoria} params={{ creditDebit: 'debit' }} />
                </ZContainerCol>
            </ZContainer>
            <div class="nota">
                <code>&lt;ZentitySelect fonte="conta" bind:value={'{'}entity.account{'}'} params={'{{'} bank {'}}'} /&gt;</code><br />
                <b>value é a entidade</b>, não o id. Fonte nova = uma entrada em <code>zentity-select.ts</code>, não um componente novo. Não crie
                <code>x-select.svelte</code>.
            </div>
        </Zframe>

        <!-- ================= BLOCOS ================= -->
        <Zframe
            class="h-space"
            title="As três densidades do bloco"
            headline="Zblock é o cartão; o que muda é a densidade do cabeçalho. Zframe e ZsheetSection são apelidos dele."
        >
            <div class="lista">
                <Zblock densidade="titulo" title="titulo" headline="Formulário de tela cheia — é o que o Zframe usa.">conteúdo</Zblock>
                <Zblock densidade="rotulo" title="rotulo" meta="é o ZsheetSection">Pilha de cartões, no mobile e no desktop.</Zblock>
                <Zblock densidade="barra" title="barra" meta="é o Zgrid2">Tabela: nome e ferramentas na mesma linha.</Zblock>
            </div>
            <div class="nota">
                Mesmo cartão nas três: raio 10px, fundo translúcido, borda única. <b>Não escreva um cartão novo</b> — escolha a densidade.
            </div>
        </Zframe>

        <Zframe class="h-space" title="Blocos de conteúdo" headline="Zframe para a moldura com título; ZsheetSection para a pilha de cartões com rótulo discreto.">
            <ZsheetSection label="Cliente" meta="obrigatório">
                <ZsheetEntity initials="CS" title="Cleyton Santos" subtitle="(47) 99970-6580" removable={true} removeTitle="Trocar" />
            </ZsheetSection>
            <div style="height:12px"></div>
            <ZsheetSection label="Itens" meta="R$ 850,00">
                <div class="lista">
                    <ZsheetEntity initials="C" title="Criolipólise" subtitle="1 × R$ 800,00" clickable={true}>
                        <svelte:fragment slot="trailing"><span class="valor">R$ 800,00</span></svelte:fragment>
                    </ZsheetEntity>
                    <ZsheetEntity initials="M" title="Massagem" subtitle="1 × R$ 50,00" clickable={true}>
                        <svelte:fragment slot="trailing"><span class="valor">R$ 50,00</span></svelte:fragment>
                    </ZsheetEntity>
                    <ZsheetAdd label="Item" />
                </div>
            </ZsheetSection>
            <div class="nota">
                <b>ZsheetEntity</b> é a linha de "coisa escolhida" (cliente, item, serviço). <b>ZsheetAdd</b> é o "mais um" da lista — não use
                <code>btn btn-sm</code> para isso.
            </div>
        </Zframe>

        <!-- ================= LISTAS E OPÇÕES ================= -->
        <Zframe class="h-space" title="Linha de lista (Zoption)" headline="A linha dos painéis de busca e dos selects. Mesma linha em todo o app.">
            <Zoption title="Consulta" details={['Duração: 01:00', 'R$ 150,00']} badge="Serviço" badgeTone="green" />
            <Zoption title="Pacote mensal" details={['3 sessões']} badge="Pacote" badgeTone="amber" />
            <Zoption title="Opção escolhida" details={['com a marca de selecionado']} selected={true} />
        </Zframe>

        <!-- ================= BOTÕES ================= -->
        <Zframe class="h-space" title="Botões" headline="Salvar = primary + faSave · Excluir = red + faTrashAlt · Voltar = secondary + faAngleLeft.">
            <div class="botoes">
                <Zbutton label="Comum" />
                <Zbutton label="Primário" color="primary" />
                <Zbutton label="Vermelho" color="red" />
                <Zbutton label="Verde" color="green" />
                <Zbutton label="Amarelo" color="yellow" />
                <Zbutton label="Ativo" color="primary" active={true} />
                <Zbutton label="Carregando" color="primary" loading={true} />
                <Zbutton label="Desabilitado" disabled={true} />
            </div>
            <div class="botoes">
                <Zbutton icon={faPlus} title="Só ícone" />
                <Zbutton icon={faTrashAlt} color="red" title="Excluir" />
                <Zbutton icon={faCheck} color="green" title="Confirmar" />
                <Zinput class="flex-grow-1" label="Campo na mesma linha" type="text" bind:value={text} />
            </div>
            <div class="nota">Botão só de ícone precisa de <code>title</code>: é o que o leitor de tela anuncia e o que aparece no hover.</div>
        </Zframe>

        <!-- ================= MICRO-INTERAÇÃO (em avaliação) ================= -->
        <Zframe
            class="h-space"
            title="Micro-interação do botão"
            headline="Clique nos três grupos e compare. O padrão do app continua sendo o primeiro — nada mudou nas telas."
        >
            <div class="motion-linha">
                <div class="motion-col">
                    <div class="motion-titulo">Hoje <span>motion="none"</span></div>
                    <div class="botoes">
                        <Zbutton label="Salvar" color="primary" icon={faCheck} />
                        <Zbutton label="Voltar" />
                        <Zbutton icon={faTrashAlt} color="red" title="Excluir" />
                    </div>
                    <div class="motion-nota">O fundo pisca no clique. A cor leva meio segundo para mudar, então a mão chega antes.</div>
                </div>

                <div class="motion-col">
                    <div class="motion-titulo">Afunda <span>motion="press"</span></div>
                    <div class="botoes">
                        <Zbutton motion="press" label="Salvar" color="primary" icon={faCheck} />
                        <Zbutton motion="press" label="Voltar" />
                        <Zbutton motion="press" icon={faTrashAlt} color="red" title="Excluir" />
                    </div>
                    <div class="motion-nota">Encolhe 3% em 90ms, como tecla de verdade, e os tempos caem para 140ms.</div>
                </div>

                <div class="motion-col">
                    <div class="motion-titulo">Afunda e ondula <span>motion="ripple"</span></div>
                    <div class="botoes">
                        <Zbutton motion="ripple" label="Salvar" color="primary" icon={faCheck} />
                        <Zbutton motion="ripple" label="Voltar" />
                        <Zbutton motion="ripple" icon={faTrashAlt} color="red" title="Excluir" />
                    </div>
                    <div class="motion-nota">O mesmo do afunda, mais a onda que nasce no ponto em que você clicou. Clique nas bordas para ver.</div>
                </div>
            </div>
            <div class="motion-linha">
                <div class="motion-col">
                    <div class="motion-titulo">A cor entra <span>motion="cor"</span></div>
                    <div class="botoes">
                        <Zbutton motion="cor" label="Salvar" color="primary" icon={faCheck} />
                        <Zbutton motion="cor" label="Voltar" />
                        <Zbutton motion="cor" icon={faTrashAlt} color="red" title="Excluir" />
                    </div>
                    <div class="motion-nota">
                        No hover o botão se preenche com a própria cor, a borda acende e nasce uma sombra na cor dele. O preenchido clareia em vez de lavar.
                    </div>
                </div>

                <div class="motion-col">
                    <div class="motion-titulo">Faixa de luz <span>motion="brilho"</span></div>
                    <div class="botoes">
                        <Zbutton motion="brilho" label="Salvar" color="primary" icon={faCheck} />
                        <Zbutton motion="brilho" label="Voltar" />
                        <Zbutton motion="brilho" icon={faTrashAlt} color="red" title="Excluir" />
                    </div>
                    <div class="motion-nota">A cor entra igual, e uma faixa de luz atravessa o botão uma vez quando o mouse chega. Saia e volte para repetir.</div>
                </div>

                <div class="motion-col">
                    <div class="motion-titulo">Halo no cursor <span>motion="foco"</span></div>
                    <div class="botoes">
                        <Zbutton motion="foco" label="Salvar" color="primary" icon={faCheck} />
                        <Zbutton motion="foco" label="Voltar" />
                        <Zbutton motion="foco" icon={faTrashAlt} color="red" title="Excluir" />
                    </div>
                    <div class="motion-nota">A cor entra igual, e um brilho da cor do botão segue o cursor por dentro dele. No clique, a onda.</div>
                </div>
            </div>

            <div class="nota">
                Sem biblioteca. Cor, borda e sombra são transição de CSS; a faixa de luz anda pela posição do gradiente (o navegador só repinta) e a onda e o
                halo são poucas linhas com a API de animação do próprio navegador. Cada cor publica os tons que as variantes usam, então a mesma regra serve
                para o vermelho, o amarelo e o secundário. Quem pede menos movimento no sistema operacional fica só com a cor, sem nada se mexendo.
            </div>
        </Zframe>

        <!-- ================= AÇÃO PRINCIPAL DO CELULAR ================= -->
        <Zframe
            class="h-space"
            title="Botão flutuante do celular"
            headline="Zfab — a ação principal da tela no celular: Agendar na agenda, Nova venda no PDV. Uma por tela."
        >
            <div class="nota">
                <code>&lt;Zfab label="Nova venda" icon={'{'}faPlusCircle{'}'} on:click={'{'}newEntity{'}'} /&gt;</code><br />
                Ele só existe abaixo de 900px — no desktop a mesma ação fica no <code>Zact</code> ou nos acts do grid, e a tela decide qual dos dois mostrar.
                Acompanha a barra inferior do app e some ao chegar no fim da rolagem, para não cobrir os botões do último item da lista.
                <b>Numa tela estreita ele está aqui no canto: role até o fim e veja-o sumir.</b>
            </div>
        </Zframe>
        <Zfab label="Exemplo" icon={faPlus} />

        <!-- ================= GRADE ================= -->
        <Zframe class="h-space" title="Grade de 12 colunas" headline="ZContainer distribui; size no desktop, sizeM no celular. ZContainerRow ocupa a linha inteira.">
            <ZContainer gapRow="8px" gapCol="8px">
                <Zinput size={5} sizeM={12} label="size 5" type="text" value="" />
                <Zinput size={2} sizeM={4} label="2" type="text" value="" />
                <Zinput size={2} sizeM={4} label="2" type="text" value="" />
                <Zinput size={2} sizeM={4} label="2" type="text" value="" />
                <ZContainerCol size={1} sizeM={12} flex={true}>
                    <Zbutton grow={true} class="me-2" color="red" icon={faTrashAlt} title="Excluir" />
                    <Zbutton grow={true} color="green" icon={faCheck} title="Confirmar" />
                </ZContainerCol>
                <ZContainerRow>
                    <div class="spacer"></div>
                    <Zbutton label="ZContainerRow ocupa as 12 colunas" color="secondary" />
                </ZContainerRow>
            </ZContainer>
        </Zframe>
    </div>
</Content>

<style>
    .showcase :global(.zframe) {
        margin-bottom: 12px;
    }
    .nota {
        margin-top: 12px;
        font-size: 13px;
        opacity: 0.7;
        line-height: 1.5;
    }
    .nota :global(code) {
        font-size: 12px;
    }
    .botoes {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        align-items: center;
        margin-bottom: 8px;
    }

    /* comparação das micro-interações: três colunas lado a lado, uma por jeito */
    .motion-linha {
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
    }
    .motion-col {
        flex: 1 1 240px;
        min-width: 240px;
        padding: 12px;
        border-radius: 10px;
        background-color: #99999910;
    }
    .motion-titulo {
        font-weight: 600;
        margin-bottom: 10px;
    }
    .motion-titulo span {
        font-weight: 400;
        opacity: 0.6;
        font-size: 12px;
        margin-left: 6px;
    }
    .motion-nota {
        font-size: 12px;
        opacity: 0.7;
        line-height: 1.35;
    }
    .lista {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }
    .valor {
        font-size: 14px;
        font-weight: 600;
        white-space: nowrap;
    }
</style>
